import { createAction, props } from "@ngrx/store";

export const setList = createAction(
    '[Sale] set list',
    props<{ list: any }>()
);

export const setCreateToSaleState = createAction(
    '[Sale] set create object',
    props<{ create: any, isEdit?: boolean }>()
)

export const resetSaleObjectState = createAction(
    '[Sale] reset sale object',
)

export const setIsEditFormSaleState = createAction(
    '[Sale] set is edit form',
    props<{ isEdit: boolean }>()
)

export const setSaleState = createAction(
    '[Sale] set sale',
    props<{ sale: any }>()
)

